type TaskType = (token?: string) => void; 

export const createTokenRefreshManager = () => {
  let tasks: TaskType[] = [];
  let isRefreshing: boolean = false;

  // 싱글톤 인스턴스 관리
  let instance: ReturnType<typeof createTokenRefreshManager>;

  const getManager = () => {
    if (!instance) {
      instance = createTokenRefreshManager();
    }
    return instance;
  };

  return {
    startRefreshing: () => {
      isRefreshing = true;
    },

    finishRefreshing: (token?: string) => {
      isRefreshing = false;
      tasks.forEach(task => task(token));
      tasks = [];
    },

    getIsRefreshing: () => isRefreshing,

    pushTask: (task: TaskType) => {
      tasks.push(task);
    },

    pushTasks: (newTasks: TaskType[]) => {
      tasks.push(...newTasks);
    },

    getTasks: () => tasks,

    getInstance: getManager,
  };
};

// 싱글톤 인스턴스 생성
export const tokenRefreshManager = createTokenRefreshManager();
